module.exports = __webpack_public_path__ + "img/Yana.64bdda99.jpg";